import { useQuery } from '@tanstack/react-query';
import { getTown } from '@/services/admin/towns';

export const useTownQuery = (siteType: string, id: number | null) => {
  return useQuery({
    queryKey: ['admin', 'town-detail', siteType, id],
    queryFn: () => getTown(siteType, id!),
    enabled: !!siteType && id !== null && id > 0,
    staleTime: 0,
    gcTime: 0,
  });
};
